export const contactsData = {
  email: "rahulyo954030@gmail.com",
  phone: "+91-8810632895",
  address: "Saket, New Delhi - 110017",
  location: "https://www.google.com/maps/place/Saket,+New+Delhi,+Delhi+110017/@28.5235666,77.2001695,15z/data=!3m1!4b1!4m5!3m4!1s0x390ce1f0dd053fdd:0x97d95c1a5860139f!8m2!3d28.5220971!4d77.2101534?hl=en",
  sheetAPI: "",
};
